import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import vuetify from "./plugins/vuetify";
import User from "./User";

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URI;

Vue.axios.interceptors.request.use(async (config) => {
  let user = localStorage.getItem("user");

  if (config.url !== undefined && (config.url.includes("/arma/") || config.url.includes("/users/userPromotionMessages")) && config.method !== "OPTIONS") {
    if (user !== null) {
      const validUntil = new Date(JSON.parse(user).validUntil);
      const now = new Date();
      const difference = validUntil.valueOf() - now.valueOf();

      if (difference < 0) {
        await User.logout();
      }

      const day = 1000 * 60 * 60 * 24;
      const sixDays = day * 6;

      if (difference < sixDays) {
        await User.refresh();
      }
    }

    user = localStorage.getItem("user");
    if (user !== null && config.headers !== undefined) {
      config.headers.Authorization = `Bearer ${JSON.parse(user).accessToken}`;
    }
  }

  return config;
});

Vue.axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorObject = {
      message: error.message,
      headers: error.config.headers,
      method: error.config.method,
      url: error.config.url,
    };

    store.dispatch("setLastError", errorObject);
    store.dispatch("setShowErrorDialog", true);
  }
);

router.beforeEach((to, from, next) => {
  const splitPath = to.path.split("/");

  if (
    splitPath.find((value: String, index: number) => {
      return value === "events" && splitPath[index + 1];
    })
  ) {
    document.title = splitPath.pop() + " – Newfound Pioneer Corps Arma 3";
  } else if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "Newfound Pioneer Corps Arma 3";
  }

  if (to.meta.tags) {
    to.meta.tags.forEach((element: any) => {
      let tag = document.createElement("meta");

      Object.keys(element).forEach((name: string) => {
        tag.setAttribute(name, element[name]);
      });

      document.head.appendChild(tag);
    });
  }
  next();
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
